module.exports = __webpack_public_path__ + "static/media/download.c08ba643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download.svg
// module id = 270
// module chunks = 0